import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
//import css from './table.module.less';
import SizeFittingTable from '@/src/components/Antd/Table/SizeFittingTable';
import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import { useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { modal } from '@/src/utils/Modal';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import {
  deletePromotionTags,
  getPromotionTags,
} from 'src/request/salesChannel/promotionTag';
import { generalSort } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
const ExpireTable = (props) => {
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { userPermissions } = props;
  const { uuid: salesChannelUuid }: any = useParams();
  const h = useHistory();
  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  //const [total, setTotal] = React.useState(0);

  React.useEffect(() => {
    getPromotionTags(salesChannelUuid, 'Expired').then((res) => {
      setData(res);
    });
  }, []);

  const col = [
    {
      title: getI18n('salesChannelPromotionTag.index.tagTitle'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => {
        const name1 = a.title || '';
        const name2 = b.title || '';
        return generalSort(name1, name2);
      },
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { title } = record;
        return (
          <NoWrapContainer>
            <Tooltip title={title}>{title}</Tooltip>
          </NoWrapContainer>
        );
      },

      minWidth: 200,
    },
    {
      title: getI18n('salesChannelPromotionTag.index.numberofProducts'),
      // dataIndex: 'number',
      key: 'number',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { linkedProducts } = record;
        const len = (linkedProducts || []).length;
        return (
          <NoWrapContainer>
            <Tooltip title={len}>{len}</Tooltip>
          </NoWrapContainer>
        );
      },

      fixedWidth: 160,
    },

    {
      title: `${getI18n(
        'salesChannelPromotionTag.index.startTime',
      )} (GMT ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'createdTime',
      default: true,
      optional: false,
      sorter: (a, b) => {
        const t1 = a.startTime || '';
        const t2 = b.startTime || '';
        if (!t1 && t2) {
          return -1;
        }
        if (t1 && !t2) {
          return 1;
        }
        if (!t1 && !t2) {
          return 0;
        }
        return moment(t1).isSameOrBefore(moment(t2));
      },
      childGenerate: (url, record) => {
        const { startTime } = record;
        const t = moment(startTime).format('DD MMM YYYY  HH:mm');
        return startTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },

      fixedWidth: 200,
    },
    {
      title: `${getI18n(
        'salesChannelPromotionTag.index.endTime',
      )} (GMT ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'finishTime',
      sorter: (a, b) => {
        const t1 = a.endTime || '';
        const t2 = b.endTime || '';
        if (!t1 && t2) {
          return -1;
        }
        if (t1 && !t2) {
          return 1;
        }
        if (!t1 && !t2) {
          return 0;
        }
        return moment(t1).isSameOrBefore(moment(t2));
      },
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { endTime } = record;
        const t = moment(endTime).format('DD MMM YYYY  HH:mm');
        return endTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },
      fixedWidth: 200,
    },
    (userPermissions.canDelete || userPermissions.canViewDetails) && {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      dataIndex: 'action',
      default: true,
      optional: true,
      key: 'action',
      //className: css.columnClass,
      fixedWidth: 128,
      childGenerate: (text, record, index) => {
        const { uuid } = record;
        return (
          <Action
            onEdit={
              userPermissions.canViewDetails &&
              (() => {
                h.push(
                  `/salesChannel/promotionTag/editor/${salesChannelUuid}/${uuid}`,
                );
              })
            }
            onDelete={
              userPermissions.canDelete &&
              (() => {
                modal.error({
                  title: getI18n(
                    'salesChannelPromotionTag.index.deletePromotionTag',
                  ),
                  content: getI18n(
                    'salesChannelPromotionTag.index.deletePromotionTagErrtitle',
                  ),
                  onOkText: getI18n('general.delete'),
                  onOk: () => {
                    setLoading(true);
                    deletePromotionTags({
                      salesChannelUuid,
                      uuids: [uuid],
                    }).then((res) => {
                      const _d = data.filter((i) => uuid !== i.uuid);
                      setData(_d);
                      msg.success(
                        getI18n(
                          'salesChannelPromotionTag.index.tagshavebeendeleted',
                        ),
                      );
                      setLoading(false);
                    });
                  },
                });
              })
            }
          />
        );
      },
    },
  ];

  const buttonMenu = [
    //Bulk Edit
    {
      key: '1',
      value: getI18n('salesChannelPromotionTag.index.deleteTags'),
      function: () => {
        //console.log('selectedRowKeys', selectedRowKeys);

        modal.error({
          title: getI18n('salesChannelPromotionTag.index.deletePromotionTag'),
          content: getI18n(
            'salesChannelPromotionTag.index.deletePromotionTagErrtitle',
          ),
          onOkText: getI18n('general.delete'),
          onOk: () => {
            setLoading(true);
            deletePromotionTags({
              salesChannelUuid,
              uuids: selectedRowKeys,
            }).then((res) => {
              const _d = data.filter((i) => !selectedRowKeys.includes(i.uuid));
              setData(_d);
              msg.success(
                getI18n('salesChannelPromotionTag.index.tagshavebeendeleted'),
              );
              setLoading(false);
            });
          },
        });
      },
      disabled: !userPermissions.canDelete,
    },
  ];

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // //mappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(data);
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = data.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };

  return (
    <React.Fragment>
      <BulkEditor
        selectAll={selectAll}
        selectedAll={selectedAll}
        buttonMenu={buttonMenu}
        total={(data || []).length}
        dataSource={data}
        selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
        //allSelected={mappedSelectedKeys}
      />
      <SizeFittingTable
        id='salesChannelPromotionTagListExpired'
        dataSource={data}
        loading={loading}
        columns={col}
        rowSelection={rowSelection}
        rowKey='uuid'
        pagination={false}
      />
    </React.Fragment>
  );
};

export default ModalHoc(ExpireTable);
